

import { Component } from "vue-property-decorator";
import Loadable from "@share/common/service-components/loadable/Loadable.vue";
import { PagingStateInterface } from "@share/common/types/interfaces/list/PagingStateInterface";

@Component({})

export default class Paginatable extends Loadable {

    pagingState: PagingStateInterface = {
        skip: 0,
        take: 20,
        count: 0
    };

    page = 1;

    resetPagination() {
        this.page = 1;
        this.pagingState = {
            skip: 0,
            take: 20,
            count: 0
        }
    }

    turnOverPageIfNeed(itemsCount: number) {
        if (!this.isLoading && this.count > itemsCount) {
            this.page++;
            return true;
        }

        return false;
    }

    get isTheFirstPage() {
        return this.page === 1;
    }

    get count() {
        return this.pagingState.count;
    }

    get showComponentSpinner() {
        return this.isLoading && this.page === 1;
    }

    get showListSpinner() {
        return this.isLoading && this.page > 1;
    }
}

